"use strict";

var _slicedToArray = require("C:\\Users\\Owner\\dao\\buildspace-dao-starter\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("C:\\Users\\Owner\\dao\\buildspace-dao-starter\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signERC2612Permit = exports.signDaiPermit = void 0;

var rpc_1 = require("./rpc");

var lib_1 = require("./lib");

var MAX_INT = '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff';
var EIP712Domain = [{
  name: "name",
  type: "string"
}, {
  name: "version",
  type: "string"
}, {
  name: "chainId",
  type: "uint256"
}, {
  name: "verifyingContract",
  type: "address"
}];

var createTypedDaiData = function createTypedDaiData(message, domain) {
  var typedData = {
    types: {
      EIP712Domain: EIP712Domain,
      Permit: [{
        name: "holder",
        type: "address"
      }, {
        name: "spender",
        type: "address"
      }, {
        name: "nonce",
        type: "uint256"
      }, {
        name: "expiry",
        type: "uint256"
      }, {
        name: "allowed",
        type: "bool"
      }]
    },
    primaryType: "Permit",
    domain: domain,
    message: message
  };
  return typedData;
};

var createTypedERC2612Data = function createTypedERC2612Data(message, domain) {
  var typedData = {
    types: {
      EIP712Domain: EIP712Domain,
      Permit: [{
        name: "owner",
        type: "address"
      }, {
        name: "spender",
        type: "address"
      }, {
        name: "value",
        type: "uint256"
      }, {
        name: "nonce",
        type: "uint256"
      }, {
        name: "deadline",
        type: "uint256"
      }]
    },
    primaryType: "Permit",
    domain: domain,
    message: message
  };
  return typedData;
};

var NONCES_FN = '0x7ecebe00';
var NAME_FN = '0x06fdde03';

var zeros = function zeros(numZeros) {
  return ''.padEnd(numZeros, '0');
};

var getTokenName = function getTokenName(provider, address) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = lib_1;
            _context.next = 3;
            return rpc_1.call(provider, address, NAME_FN);

          case 3:
            _context.t1 = _context.sent.substr(130);
            return _context.abrupt("return", _context.t0.hexToUtf8.call(_context.t0, _context.t1));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

var getDomain = function getDomain(provider, token) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var tokenAddress, _yield$Promise$all, _yield$Promise$all2, name, chainId, domain;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(typeof token !== 'string')) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", token);

          case 2:
            tokenAddress = token;
            _context2.next = 5;
            return Promise.all([getTokenName(provider, tokenAddress), rpc_1.getChainId(provider)]);

          case 5:
            _yield$Promise$all = _context2.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            name = _yield$Promise$all2[0];
            chainId = _yield$Promise$all2[1];
            domain = {
              name: name,
              version: '1',
              chainId: chainId,
              verifyingContract: tokenAddress
            };
            return _context2.abrupt("return", domain);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};

exports.signDaiPermit = function (provider, token, holder, spender, expiry, nonce) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var tokenAddress, message, domain, typedData, sig;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            tokenAddress = token.verifyingContract || token;
            _context3.t0 = holder;
            _context3.t1 = spender;
            _context3.t2 = nonce;

            if (_context3.t2) {
              _context3.next = 8;
              break;
            }

            _context3.next = 7;
            return rpc_1.call(provider, tokenAddress, "".concat(NONCES_FN).concat(zeros(24)).concat(holder.substr(2)));

          case 7:
            _context3.t2 = _context3.sent;

          case 8:
            _context3.t3 = _context3.t2;
            _context3.t4 = expiry || MAX_INT;
            message = {
              holder: _context3.t0,
              spender: _context3.t1,
              nonce: _context3.t3,
              expiry: _context3.t4,
              allowed: true
            };
            _context3.next = 13;
            return getDomain(provider, token);

          case 13:
            domain = _context3.sent;
            typedData = createTypedDaiData(message, domain);
            _context3.next = 17;
            return rpc_1.signData(provider, holder, typedData);

          case 17:
            sig = _context3.sent;
            return _context3.abrupt("return", Object.assign(Object.assign({}, sig), message));

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};

exports.signERC2612Permit = function (provider, token, owner, spender) {
  var value = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : MAX_INT;
  var deadline = arguments.length > 5 ? arguments[5] : undefined;
  var nonce = arguments.length > 6 ? arguments[6] : undefined;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var tokenAddress, message, domain, typedData, sig;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            tokenAddress = token.verifyingContract || token;
            _context4.t0 = owner;
            _context4.t1 = spender;
            _context4.t2 = value;
            _context4.t3 = nonce;

            if (_context4.t3) {
              _context4.next = 9;
              break;
            }

            _context4.next = 8;
            return rpc_1.call(provider, tokenAddress, "".concat(NONCES_FN).concat(zeros(24)).concat(owner.substr(2)));

          case 8:
            _context4.t3 = _context4.sent;

          case 9:
            _context4.t4 = _context4.t3;
            _context4.t5 = deadline || MAX_INT;
            message = {
              owner: _context4.t0,
              spender: _context4.t1,
              value: _context4.t2,
              nonce: _context4.t4,
              deadline: _context4.t5
            };
            _context4.next = 14;
            return getDomain(provider, token);

          case 14:
            domain = _context4.sent;
            typedData = createTypedERC2612Data(message, domain);
            _context4.next = 18;
            return rpc_1.signData(provider, owner, typedData);

          case 18:
            sig = _context4.sent;
            return _context4.abrupt("return", Object.assign(Object.assign({}, sig), message));

          case 20:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
};